const InstallationModule = {
    state: {
        displaySelectProductModal: false,
        displayInstallationProgress: false,
        displaySuperQuickInstallationProgress: false,
        displayStandardForm: false,
        displayLimitModal: false,
        displayZeroDataModal: false,
        displayChooseTemplate: false,
        displayWebsiteInstallationModal: false,
        displayWebsiteDomainModal: false,
        displayChooseUserConfigurableOptionsModal: false,
        displayChooseOnboardingTypeModal: false,
        displayChooseCreationTypeModal: false,
        displayChooseImportMethodModal: false,
        displayImportInstanceUrlSettingsModal: false,
        displayImportAdvancedMethodModal: false,
        displayImportSimpleMethodModal: false,
        displayImportInstanceSetupCompleteModal: false,
        displayImportChooseServiceModal: false,
        displayDomainTransferModal: false,
        displayChooseUserModal: false,
        displayShareAccessModal: false,
        displayChooseUserConfigurationOptionsModal: false,
        displaySyncInstancesProgressModal: false,
				displayDomainDnsVerificationModal: false,
        displayChooseServiceModal: false,
        displayChooseSiteNameModal: false,
    },
    mutations: {
        deactivateAll(state) {
            state.displaySelectProductModal = false
            state.displayInstallationProgress = false
            state.displaySuperQuickInstallationProgress = false
            state.displayLimitModal = false
            state.displayZeroDataModal = false
            state.displayChooseTemplate = false
            state.displayStandardForm = false
            state.displayWebsiteInstallationModal = false
            state.displayWebsiteDomainModal = false
            state.displayChooseUserConfigurableOptionsModal = false
            state.displayChooseOnboardingTypeModal = false
            state.displayChooseCreationTypeModal = false
            state.displayImportInstanceUrlSettingsModal = false
            state.displayImportAdvancedMethodModal = false
            state.displayImportSimpleMethodModal = false
            state.displayImportInstanceSetupCompleteModal = false
            state.displayImportChooseServiceModal = false
            state.displayDomainTransferModal = false
            state.displayChooseUserModal = false
            state.displayShareAccessModal = false
            state.displayChooseUserConfigurationOptionsModal = false
            state.displaySyncInstancesProgressModal = false
						state.displayDomainDnsVerificationModal = false
            state.displayChooseServiceModal = false
            state.displayChooseSiteNameModal = false
            state.displayChooseImportMethodModal = false
        },
        activateModal(state, payload) {
            state[payload] = true
        },
    },
    actions: {
        displayChooseOnboardingTypeModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseOnboardingTypeModal')
        },
        displayWebsiteInstallationModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayWebsiteInstallationModal')
        },
        displayWebsiteDomainModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayWebsiteDomainModal')
        },
        displayChooseUserConfigurableOptionsModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseUserConfigurableOptionsModal')
        },
        displaySelectProductModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displaySelectProductModal')
        },
        displayInstallationProgress: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayInstallationProgress')
        },
        displaySuperQuickInstallationProgress: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displaySuperQuickInstallationProgress')
        },
        displayLimitModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayLimitModal')
        },
        displayZeroDataModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayZeroDataModal')
        },
        displayChooseTemplate: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseTemplate')
        },
        displayStandardForm: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayStandardForm')
        },
        deactivateAll: function (context) {
            context.commit('deactivateAll')
        },
        displayChooseCreationTypeModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseCreationTypeModal')
        },
        displayImportInstanceUrlSettingsModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayImportInstanceUrlSettingsModal')
        },
        displayImportAdvancedMethodModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayImportAdvancedMethodModal')
        },
        displayImportSimpleMethodModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayImportSimpleMethodModal')
        },
        displayImportInstanceSetupCompleteModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayImportInstanceSetupCompleteModal')
        },
        displayDomainTransferModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayDomainTransferModal')
        },
        displayChooseUserModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseUserModal')
        },
        displayShareAccessModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayShareAccessModal')
        },
        displayChooseUserConfigurationOptionsModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseUserConfigurationOptionsModal')
        },
        displaySyncInstancesProgressModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displaySyncInstancesProgressModal')
        },
				displayDomainDnsVerificationModal: function (context) {
						context.commit('deactivateAll')
						context.commit('activateModal', 'displayDomainDnsVerificationModal')
				},
        displayChooseServiceModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseServiceModal')
        },
        displayChooseSiteNameModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseSiteNameModal')
        },
        displayChooseImportMethodModal: function (context) {
            context.commit('deactivateAll')
            context.commit('activateModal', 'displayChooseImportMethodModal')
        },
        startInstallationProcess: function () {
        },
    }
}

export default InstallationModule